import type React from 'react';

import { StaffDrawer, StaffDrawerInfo, StaffDrawerLink, StaffDrawerSection } from '#src/app/shared/components/staff';

import { useHomepageStaffDrawer } from './hooks/useHomepageStaffDrawer';

export const HomepageStaffDrawer: React.FC<EmptyProps> = () => {
	const {
		data: { marqueeItemCount, topImpactStoryCount, urls },
	} = useHomepageStaffDrawer();

	return (
		<StaffDrawer>
			<StaffDrawerSection title="Curated content">
				<StaffDrawerInfo label="Marquee items" value={marqueeItemCount} />
				<StaffDrawerInfo label="Top impact stories" value={topImpactStoryCount} />
				<StaffDrawerLink href={urls.featuredPetitions}>Featured petitions</StaffDrawerLink>
				<StaffDrawerLink href={urls.featuredTopics}>Featured topics</StaffDrawerLink>
				<StaffDrawerLink href={urls.featuredVictories}>Featured victories</StaffDrawerLink>
			</StaffDrawerSection>
			<StaffDrawerSection title="Shortcuts">
				<StaffDrawerLink href={urls.adminHome}>Admin home</StaffDrawerLink>
				<StaffDrawerLink href={urls.userSearch}>User search</StaffDrawerLink>
				<StaffDrawerLink href={urls.dmSearch}>DM search</StaffDrawerLink>
			</StaffDrawerSection>
		</StaffDrawer>
	);
};
